import React from 'react';
import {
  homepagePrimaryButtonClassName,
  homepageSectionContainerClassName,
  sectionHeadingAccentCenterClassName,
} from '../constants/homepageUi';

const HomepageClosingCTASection: React.FC = () => {
  return (
    <section
      className="scroll-mt-20 border-t border-[rgba(255,255,255,0.05)] bg-[#0B0F14] py-20 lg:py-28 xl:py-32"
      aria-labelledby="homepage-closing-cta-heading"
    >
      <div className={`${homepageSectionContainerClassName} flex flex-col items-center text-center`}>
        <h2
          id="homepage-closing-cta-heading"
          className={`mb-5 max-w-2xl text-3xl font-bold leading-tight tracking-tight text-white sm:mb-6 sm:text-4xl lg:text-[2.25rem] ${sectionHeadingAccentCenterClassName} inline-block`}
        >
          Ready to Get the Right Dataset?
        </h2>
        <p className="mb-10 max-w-xl text-base leading-relaxed text-white/80 sm:mb-11 sm:text-lg">
          We offer both existing datasets and custom data collection — tell us what you need and we&apos;ll walk you
          through options, samples, and next steps.
        </p>
        <a href="/request-dataset" className={homepagePrimaryButtonClassName}>
          Request a Dataset
        </a>
      </div>
    </section>
  );
};

export default HomepageClosingCTASection;
